import { gql } from "@apollo/client";

export const GET_RECORD_GROUPS = gql`
  query GetRecordGroups($group_type: RecordGroupType!, $owner_agent_id: Int!, $member_id: Int) {
    getRecordGroups(group_type: $group_type, owner_agent_id: $owner_agent_id, member_id: $member_id) {
      success
      message
      error
      member_group_ids
      data {
        group_id
        group_name
        owner_agent_id
        group_members
        is_member
      }
    }
  }
`;

export const GET_RECORD_GROUP_MEMBERS = gql`
  query GetRecordGroupMembers($group_type: RecordGroupType!, $owner_agent_id: Int!, $group_id: Int!) {
    getRecordGroupMembers(group_type: $group_type, owner_agent_id: $owner_agent_id, group_id: $group_id) {
      success
      member_group_ids
      error
    }
  }
`;
